<script lang="ts">
	import celticScriptFont from '#fonts/CelticScript-Regular.woff2?url';
	import '#styles/app.css';
	import { onNavigate } from '$app/navigation';
	import type { Snippet } from 'svelte';
	import { Page } from '#lib/components/ui/index.ts';
	import Header from './Header.svelte';

	let { children }: { children: Snippet } = $props();

	onNavigate(async (navigation) => {
		if (!document.startViewTransition) return;

		return new Promise((oldStateCaptureResolve) => {
			document.startViewTransition(async () => {
				oldStateCaptureResolve();
				await navigation.complete;
			});
		});
	});
</script>

<svelte:head>
	<link rel="preload" href={celticScriptFont} as="font" type="font/woff2" crossorigin="anonymous" />
</svelte:head>

<Header />
<Page>
	{@render children()}
</Page>
